import { render, staticRenderFns } from "./PromptEditSale.vue?vue&type=template&id=d5ec5bbc&scoped=true&"
import script from "./PromptEditSale.vue?vue&type=script&lang=js&"
export * from "./PromptEditSale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5ec5bbc",
  null
  
)

export default component.exports